import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {

  @Input() header = 'Confirmation';
  @Input() body = 'Are you sure you want to perform this action?';
  @Input() positiveButtonText = 'Proceed';
  @Input() negativeButtonText = 'Cancel';
  @Input() dismissOnConfirm = true;
  @Input() showCancel = true;
  @Input() showLoadingOnConfirmClick = true;
  @Output()
  onConfirmClicked = new EventEmitter();
  @Input() loading = false;

  constructor(
      public modalRef: BsModalRef,
  ) {
  }



  ngOnInit(): void {
  }

  onConfirm: any = () => {
  };

  close() {
    this.modalRef.hide();
  }

  confirm() {
    if (this.showLoadingOnConfirmClick) {
      this.loading = true;
    }
    this.onConfirm();
    this.onConfirmClicked.emit();
    if (this.dismissOnConfirm) {
      this.modalRef.hide();
    }
  }
}
